export enum QuotesRFQApi {
  ExportPDF = '/quote/:quoteId/rfq-export-pdf',
  PreviewPDF = '/quote/:quoteId/rfq-export-preview',
  Get = '/quote/:quoteId',
  UpdateProfilePhoto = '/quote/:quoteId/uploadProfileImage',
  UpdatePreviewInfo = '/quote/:quoteId/previewInfo',
  Update = '/quote/:quoteId/edit-quote',
  UpdateItem = '/quote/:quoteId/item',
  Configurations = '/quote/configuration',
  Create = '/quote/create',
  GetStatuses = '/quote/statuses',
  UpdateQuoteStatus = '/quote/:quoteId/status',
  RenewQuotes = '/quote/:quoteId/renew',
  DeleteQuote = '/quote/:quoteId',
  Summary = '/quote/summary-stats'
}
